import type { FC, ReactNode } from 'react'

import { useSelector } from 'react-redux'

import { selectUser } from '@web/entities/user/model/auth.selector'
import { NotAccess } from '@web/pages/not-access'
import type { EUserRole } from '@web/shared/enums/user/user-role.enum'

type TProps = {
  roles: EUserRole[]
  children: ReactNode
}

const RequireRole: FC<TProps> = ({ roles, children }) => {
  const user = useSelector(selectUser)
  const hasRole = user?.role ? roles.includes(user.role) : false

  return hasRole ? <>{children}</> : <NotAccess />
}

export default RequireRole
